<template>
    <div>
         <b-field class="commonrules-grp" label="The vehicle size is above">
            <b-select class="cstmb-input" v-model="carSize" @input="$emit('carSize',carSize)">
                <option
                    v-for="(item, key) in options"
                    :key="key"
                    :value="key"
                    :selected="key === 0"
                >
                    {{ item }}
                </option>

           </b-select>
        </b-field>
    </div>
</template>
<script>
export default{
    name : "CarSize",
    props:{carsizeis:null},
    data(){
        return{
             carSize : null
        }
    },
    computed: {
        options() {
            return this.$store.state.options.carSizes;
        }
    },
    methods:{
    },
    mounted() {
        this.carSize = this.carsizeis;
    }
}
</script>